import { Skeleton } from "antd";

import { cn } from "@btnet/utilities-core";

interface IWhatsNewCardSkeletonProps {
    className?: string;
}

export function WhatsNewCardSkeleton({ className }: Readonly<IWhatsNewCardSkeletonProps>) {
    return (
        <div className={cn("WhatsNewCardSkeleton", className)}>
            <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 2 }} />
        </div>
    );
}
